import { ApiError } from 'api/api-error';
import { Exclude, Expose } from 'class-transformer';
import { CatalogueExtended } from './catalogue-extended';

/**
 * Response when updating a catalogue.
 */
@Exclude()
export class UpdateCatalogueResult {
  /**
   * The api errors.
   */
  @Expose()
  errors: ApiError[];

  /**
   * The updated catalogue.
   */
  @Expose()
  catalogue: CatalogueExtended;
}
